import { Box, Stack, Typography } from '@mui/material';

import { language } from '@/ui/i18n';
import { Fonts } from '@/ui/theme/fonts';

export type ScoreBarPosition = 'higher' | 'normal' | 'lower';
export type ScoreBarDirection = 'horizontal' | 'vertical';

export function HorizontalScoreBar({
  value,
  color,
  backColor,
  position,
}: {
  value: number;
  color: string;
  backColor: string;
  position: ScoreBarPosition;
}) {
  // const getHeight = (): string | number => {
  //   switch (position) {
  //     case 'higher':
  //       return direction === 'horizontal' ? 50 : 130;
  //     case 'normal':
  //       return direction === 'horizontal' ? 50 : 115;
  //     case 'lower':
  //       return direction === 'horizontal' ? 50 : 100;
  //   }
  // };

  // const getWidth = (): string | number => {
  //   switch (position) {
  //     case 'higher':
  //       return direction === 'horizontal' ? '100%' : 50;
  //     case 'normal':
  //       return direction === 'horizontal' ? '90%' : 50;
  //     case 'lower':
  //       return direction === 'horizontal' ? '80%' : 50;
  //   }
  // };

  const getWidth = (): string | number => {
    switch (position) {
      case 'higher':
        return '100%';
      case 'normal':
        return '90%';
      case 'lower':
        return '80%';
    }
  };

  return (
    <Box position={'relative'} height={50} width={getWidth()}>
      <Box
        sx={{
          backgroundColor: backColor,
          height: '100%',
          width: '100%',
          borderRadius: 2,
        }}
      />
      <Stack
        sx={{
          backgroundColor: color,
          minHeight: 50,
          minWidth: 50,
          paddingX: 1,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 2,
          position: 'absolute',
          top: 0,
          right: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: '1.75rem',
            fontWeight: '900',
            fontFamily: Fonts.DarkerGrotesque,
          }}
        >
          {value ? value.toLocaleString(language) : '-'}
        </Typography>
      </Stack>
    </Box>
  );
}
